import type { IntlShape } from "react-intl";

export enum OccurrenceTypeEnum {
  PREVENTIVE = 'P',
  CORRECTIVE = 'C',
  ASSISTANCE = 'A',
  WINCH = 'W',
  IN_DEALERSHIP = 'D',
}

export enum OccurrenceTypeLabelEnum {
  P = 'Preventiva',
  C = 'Corretiva',
  PC = 'Preventiva e Corretiva',
  A = 'Socorro',
  W = 'Guincho',
  D = 'Na Concessionária',
  CL = 'Sinistro',
}

export const OccurrenceTypeLabelIdMap: Record<keyof typeof OccurrenceTypeLabelEnum, string> = {
  P: 'intl-msg:kanban.form.vehicleChildForm.preventive',
  C: 'intl-msg:kanban.form.vehicleChildForm.corrective',
  PC: 'intl-msg:kanban.form.vehicleChildForm.preventiveAndCorrective',
  A: 'intl-msg:kanban.form.vehicleChildForm.roadAssistance',
  W: 'intl-msg:kanban.form.vehicleChildForm.towTruck',
  D: 'intl-msg:shared.occurrence.type.inDealership',
  CL: 'intl-msg:kanban.form.vehicleChildForm.claim',
};

export const getOccurrenceTypeLabelId = (occurrenceType?: string | null): string | undefined =>
  occurrenceType ? OccurrenceTypeLabelIdMap[occurrenceType as keyof typeof OccurrenceTypeLabelIdMap] : undefined;

export const formatOccurrenceTypeLabel = (intl: IntlShape, occurrenceType?: string | null): string | undefined => {
  const id = getOccurrenceTypeLabelId(occurrenceType);
  return id ? intl.formatMessage({ id }) : undefined;
}